var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// Split context and provider to enable auto-generated props docs
import { nanoid } from 'nanoid';
import { useCallback, useState } from 'react';
import Toast from './toast';
import { ToastContext } from './toast-context';
import ToastsList from './toasts-list';
function ToastProvider(_a) {
    var _b = _a.autoHideDuration, autoHideDuration = _b === void 0 ? 6000 : _b, children = _a.children, _c = _a.disableAutoHide, providerDisableAutoHide = _c === void 0 ? false : _c, _d = _a.offset, offset = _d === void 0 ? '54px' : _d;
    // Keep each new Toast in a hash map under unique ID
    var _e = __read(useState({}), 2), toasts = _e[0], setToasts = _e[1];
    var toastIds = Object.keys(toasts);
    // Create new Toast, exposed by hook
    var toast = useCallback(function (_a) {
        var description = _a.description, disableAutoHide = _a.disableAutoHide, size = _a.size, title = _a.title, _b = _a.variant, variant = _b === void 0 ? 'info' : _b;
        var toastId = nanoid(6);
        setToasts(function (newToasts) {
            var _a;
            return __assign(__assign({}, newToasts), (_a = {}, _a[toastId] = {
                autoHideDuration: autoHideDuration,
                description: description,
                disableAutoHide: disableAutoHide !== undefined // Check for individual Toast override for disableAutoHide
                    ? disableAutoHide
                    : providerDisableAutoHide,
                size: size,
                title: title,
                variant: variant,
            }, _a));
        });
    }, [autoHideDuration, providerDisableAutoHide]);
    // Remove Toast from hash map by ID
    // Handler is called by Toast after exit animation is finished
    // It's called either automatically by internal Toast timer or after close button is clicked
    function handleClose(toastId) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var _a = toasts, _b = toastId, removed = _a[_b], restToasts = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        setToasts(restToasts);
    }
    return (_jsxs(ToastContext.Provider, __assign({ value: { toast: toast } }, { children: [toastIds.length > 0 && (_jsx(ToastsList, __assign({ offset: offset }, { children: toastIds.map(function (toastId) {
                    return (_jsx(Toast, __assign({}, toasts[toastId], { onClose: function () { return handleClose(toastId); } }), toastId));
                }) }))), children] })));
}
export default ToastProvider;
